module.exports = __webpack_public_path__ + "img/role-default.24f4ecb1.svg";